import { Link } from 'react-router';
import { FilePath, EventTrack } from '../../services/utilities';
import './banner-ad.scss';

const BannerAd = (props) => {

    return (
        <div className="row marketing-banner d-print-none">
            <div className="col-12">
                <div className="mb-3">
                    <Link to={"/targeted-marketing" + ((props && props.customPath) ? props.customPath : "")} className="d-block w-100" onClick={() => EventTrack("Targeted Marketing", "Marketing Banner Clicked", "")}>
                        <video autoPlay muted loop preload="auto" aria-labelledby="marketingBannerDescr" poster={FilePath('/images/banners/targeted-marketing-poster.jpg')} height="150" width="1296" className="img-fluid" playsInline={true} >
                            <source src={FilePath('/images/banners/targeted-marketing.mp4')} type="video/mp4" />
                            Check out our Targeted Marketing tool
                        </video>
                        <span className="visually-hidden" id="marketingBannerDescr" aria-hidden>Animation: Targeted Marketing tool with map of parcels being selected.</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default BannerAd;